<ng-container>
  <div class="page-header-bar">
    <div class="content85percent">
      <div class="float-start">
        <h1>Order # @if (order) {
          <span data-cy="orderId">{{order.id}}</span>
        }</h1>
      </div>
      <div class="float-end">
        <div class="btn-group" role="group">
          @if (!isCompleteCancelledOrOptout) {
            <div>
              @if ((capabilitiesService.userHasCapability('order', 'CanCancelOrder', order?.id) | async)) {
                <button class="btn btn-tertiary loan-information-header-btn"
                  (click)="cancelOrder()"
                  >
                  Cancel Order
                </button>
              }
              @if ((capabilitiesService.userHasCapability('order', 'CanCompleteOrder', order?.id) | async) && canCompleteOrder) {
                <button class="btn-secondary loan-information-header-btn"
                  (click)="completeOrder()"
                  >
                  Complete Order
                </button>
              }
            </div>
          }
          @if (!toggleLoanInformationFormEdit && !isOrderLocked && (capabilitiesService.userHasCapability('order', 'CanEditOrder', order?.id) | async)) {
            <button
              type="button"
              (click)="editLoanInformationForm()"
              class="btn-primary loan-information-header-btn">
              Edit Order
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</ng-container>
